module.exports = __webpack_public_path__ + "static/media/18_plantilla_rec_combo_simple_cf_gaseosas_stills_2,25_cepita_fresh_nar.f1fc79a2.png";